"use client"

import { useState, useEffect } from "react"
import { ArrowRight, Sparkles, Plane, Star } from "lucide-react"
import "./JoinUs.css"

const AnimatedBackgroundElement = ({ type, className, children, style }) => (
  <div className={`animated-bg-element ${type} ${className}`} style={style}>
    {children}
  </div>
)

export default function JoinUs() {
  const [email, setEmail] = useState("")
  const [feedbackMessage, setFeedbackMessage] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    setIsLoaded(true) // Trigger entrance animations on component mount
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setFeedbackMessage("Sending...")

    const emailData = { email }
    try {
      // Send the email to the backend for saving in MongoDB
      const response = await fetch("https://aeronauts-nsut.onrender.com/submit-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(emailData),
      })
      const data = await response.json()

      if (data.message === "Email submitted successfully") {
        setFeedbackMessage("Thank you for joining us!")
        setEmail("") // Clear email on success
      } else {
        setFeedbackMessage(data.error || "Something went wrong. Please try again.")
      }
    } catch (error) {
      console.error("Error:", error)
      setFeedbackMessage("Error sending form. Please check your connection.")
    } finally {
      setIsSubmitting(false)
      setTimeout(() => setFeedbackMessage(""), 5000) // Clear message after 5 seconds
    }
  }

  return (
    <section className="join-us-section">
      {/* Animated Background Elements */}
      <div className="background-elements-wrapper">
        {Array.from({ length: 10 }).map((_, i) => (
          <AnimatedBackgroundElement
            key={`star-${i}`}
            type="star"
            className={`star-${i}`}
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${5 + Math.random() * 5}s`,
            }}
          >
            <Star size={20} fill="#fbbf24" stroke="none" />
          </AnimatedBackgroundElement>
        ))}
        {Array.from({ length: 3 }).map((_, i) => (
          <AnimatedBackgroundElement
            key={`plane-${i}`}
            type="plane"
            className={`plane-${i}`}
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 8}s`,
              animationDuration: `${8 + Math.random() * 5}s`,
            }}
          >
            <Plane size={32} fill="#60a5fa" stroke="none" />
          </AnimatedBackgroundElement>
        ))}
      </div>

      <div className={`join-us-container ${isLoaded ? "loaded" : ""}`}>
        {/* MacBook-like control buttons */}
        <div className="mac-controls">
          <div className="mac-control-btn close"></div>
          <div className="mac-control-btn minimize"></div>
          <div className="mac-control-btn maximize"></div>
        </div>

        <div className="join-us-content">
          <div className="join-us-header">
            <h2 className="join-us-title">Join Our Community</h2>
            <p className="join-us-description">
              Be part of a thriving network of drone enthusiasts, researchers, and innovators. Get exclusive updates,
              event invitations, and research insights directly to your inbox.
            </p>
          </div>

          <form className="join-us-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="email"
                className="email-input"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isSubmitting}
              />
              <button type="submit" className="submit-button" disabled={isSubmitting}>
                {isSubmitting ? (
                  <span className="spinner"></span>
                ) : (
                  <>
                    Join Now <ArrowRight className="button-icon" />
                  </>
                )}
              </button>
            </div>
            {feedbackMessage && (
              <p className={`feedback-message ${feedbackMessage.includes("Error") ? "error" : "success"}`}>
                {feedbackMessage}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  )
}
